module.exports = __webpack_public_path__ + "assets/media/3.6bc774ca.wav";